"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Clear = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.9819 7.99723L11.598 5.49133L10.5024 4.50687L7.99805 7.02023L5.48625 4.50687L4.50985 5.49133L7.0142 7.99723L4.50985 10.6225L5.48625 11.5995L7.99805 9.09357L10.5024 11.5995L11.598 10.6225L8.9819 7.99723ZM7.99805 2.00098C8.79805 2.00595 9.56823 2.16754 10.3086 2.48575C11.049 2.80396 11.6875 3.23155 12.2241 3.76853C12.7608 4.30552 13.1906 4.94442 13.5136 5.68525C13.8366 6.42609 13.998 7.19675 13.998 7.99725C13.998 8.79775 13.8341 9.57089 13.5061 10.3167C12.8602 11.8133 11.7943 12.8798 10.3086 13.5162C9.56823 13.8394 8.79805 14.001 7.99805 14.001C7.19804 14.001 6.42786 13.8394 5.68749 13.5162C4.18686 12.8599 3.11855 11.7934 2.48252 10.3167C2.15954 9.58084 1.99805 8.81018 1.99805 8.00471C1.99805 7.19923 2.15954 6.42609 2.48252 5.68525C3.13345 4.19364 4.20177 3.12466 5.68749 2.47829C6.42786 2.16008 7.19804 2.00098 7.99805 2.00098Z",
    clipRule: "evenodd"
  })));
};